module.exports = __webpack_public_path__ + "static/media/stocken.ae1b319c.jpeg";